var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "base-checkbox",
      class: { "is-active": _vm.value, "is-disabled": _vm.disabled },
    },
    [
      _c("span", { staticClass: "base-checkbox__inner" }, [
        _c("span", { staticClass: "base-checkbox__box" }, [
          _c(
            "svg",
            {
              staticClass: "base-checkbox__icon",
              attrs: {
                width: "10",
                height: "8",
                viewBox: "0 0 10 8",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M8.55545 1.33203L3.66656 6.22092L1.44434 3.9987",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "base-checkbox__control",
          attrs: { type: "checkbox", disabled: _vm.disabled },
          domProps: { value: _vm.value },
          on: { change: _vm.handleChange },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "base-checkbox__label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }